import { parseApiResponse } from '@/shared/utils/apiResponse';
import { apiGet, apiPatch, apiPost } from '@/shared/utils/requestBuilder';

import type { CreateTipoPrazoDto, TipoPrazo, UpdateTipoPrazoDto } from '../types/tipoPrazoTypes';

const BASE = '/admin/arbitral/tipos-prazo';

export const tiposPrazoService = {
  async listar(): Promise<TipoPrazo[]> {
    const data = await parseApiResponse<{ items: TipoPrazo[] }>(await apiGet(BASE));
    return data.items;
  },

  async criar(data: CreateTipoPrazoDto): Promise<TipoPrazo> {
    return parseApiResponse<TipoPrazo>(await apiPost(BASE, data));
  },

  async atualizar(id: string, data: UpdateTipoPrazoDto): Promise<TipoPrazo> {
    return parseApiResponse<TipoPrazo>(await apiPatch(`${BASE}/${id}`, data));
  },

  async alternarStatus(id: string): Promise<TipoPrazo> {
    return parseApiResponse<TipoPrazo>(await apiPatch(`${BASE}/${id}/status`));
  },
};
